import { createSelector } from 'reselect';

const selectRouter = (state) => state.get('router');

const makeSelectLocation = () =>
  createSelector(selectRouter, (routerState) =>
    routerState.get('location').toJS(),
  );

export { makeSelectLocation };
